import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class RadioBlock extends MainComponent {

    static propTypes = {
        onChange: PropTypes.func,
        required: PropTypes.bool,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        disabled: PropTypes.bool,
    };
    static defaultProps = {
        onChange: null,
        required: false,
        value: "",
        disabled: false
    };

    constructor(props) {
        super(props);

        const initialSelectedIndex = this.getSelectedIndex(props.value);

        this.state = {
            selectedItem: initialSelectedIndex
        };
    }

    set value(value) {
        const index = this.getSelectedIndex(value);
        return this.changeState("selectedItem", index !== -1 ? index : false);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            const newSelectedIndex = this.getSelectedIndex(this.props.value);
            if (newSelectedIndex !== this.state.selectedItem) {
                this.setState({ selectedItem: newSelectedIndex });
            }
        }
    }

    getSelectedIndex(value) {
        return this.props.items.findIndex(it => it.value === value);
    }

    onChange(i, value) {
        const { disabled } = this.props;
        if (!disabled) {
            this.changeState("selectedItem", i);
            this._helper.dom.removeClass(this.radioButton, "unvalid");
            if (this.props.onChange?.apply)
                this.props.onChange(value);
        }
    }

    validate() {
        if (!this.props.required) {
            return true;
        }

        const { selectedItem } = this.state;

        if (selectedItem !== -1) {
            this._helper.dom.removeClass(this.radioButton, "unvalid");
            return true;
        }

        this._helper.dom.addClass(this.radioButton, "unvalid");
        return false;
    }

    render() {
        const { items, title, required, onClick, key } = this.props;
        const { selectedItem } = this.state;

        const props = {};
        if (key)
            props.key = `radioBlock${key}`;

        return (
            <div
                ref={el => this.radioButton = el}
                className={`radioBlock flex col gap8 ${required ? "required" : ""}`}
                onClick={onClick} {...props}>
                <div className={`radioBlockTitle text p2`}>{title && this.tr(title)}</div>
                {items?.map((it, i) => (<div
                    className={`radioItem ${i === selectedItem ? "active" : ""} text p1 flex gap8 hand`}
                    key={"radio" + i}
                    onClick={this.onChange.bind(this, i, it.value)}>
                    <div className="radioCircle"></div>
                    <div className="radioText">{this.tr(it.name)}</div>
                </div>))}

            </div>
        );

    }
}
